module.exports = __webpack_public_path__ + "static/media/target.d6f4a0b6.png";